import React from 'react';
import Modal from 'components/UI/Modal';
import { alert } from 'util/alert';
import "./Modal.scss";
import ModalContent from "./ModalContent";
import { confirmable } from 'react-confirm';
import locale from './locale';
import moment from 'moment';
import { connect } from 'react-redux';
import {browserHistory} from 'react-router'
import createStudent from 'controllers/student/registerStudent';
import updateStudentInfo from 'controllers/student/updateStudentInfo';
import updateStudentPhoto from 'controllers/student/updateStudentPhoto';
import Student from 'mediators/Student';

const DEFAULT_REGION_CODE = 'ca';
const mapStateToProps = (state) => ({
	student: state.student,
})

const DEFAULT_COUNTRY = "Canada";

const DEFAULT_PROVINCE = "British Columbia";

class ModalBody extends React.Component {

  constructor(props){
    super(props)

		this.state = {
      formData: {
        name: {},
      },
      customFormData: {},
      disabledBtn: false,
		}

    this.submitForm = this.submitForm.bind(this);
    this.formDataToStudent = this.formDataToStudent.bind(this);
    this.onFormChange = this.onFormChange.bind(this);
    this.onCustomDataChange = this.onCustomDataChange.bind(this);
    this.studentPhotoUploader = this.studentPhotoUploader.bind(this);
  }

	componentDidMount(){
    this.studentDataToFormData();
  }

  // studentData -> formData
  studentDataToFormData() {
    const {
      studentData,
      mode,
    } = this.props

    let formData = {}

    let customFormData = {};

		if(studentData && mode !== 'create'){
			formData = {
        name: {
          firstName: studentData.firstName,
          lastName: studentData.lastName
        },
        gender: studentData.gender,
        phoneParsed: studentData.phoneParsed.national_number? studentData.phoneParsed : {country_code: '1', national_number: '', region_code: DEFAULT_REGION_CODE},
				phone: studentData.phone,
				dob: studentData.dob,
				profilePhoto: studentData.profilePhoto,
				email: studentData.email,
				nickName: studentData.nickName,
				createdOn: studentData.createdOn,
        address: {
          street: studentData.address,
          unit: studentData.suiteNumber,
          city: studentData.city,
          country: studentData.country,
          province: studentData.province,
          postalCode: studentData.postalCode
        },
				remark: studentData.remark,
        primaryGuardian: {
          name: studentData.primaryGuardianName,
          email: studentData.primaryGuardianEmail,
          phone: studentData.primaryGuardianPhone,
          phoneParsed: studentData.primaryGuardianPhoneParsed.national_number ? studentData.primaryGuardianPhoneParsed : {country_code: '1', national_number: '', region_code: DEFAULT_REGION_CODE},
          relationship: studentData.primaryGuardianRelationship
        },
        secondaryGuardian: {
          name: studentData.secondaryGuardianName,
          email: studentData.secondaryGuardianEmail,
          phone: studentData.secondaryGuardianPhone,
          phoneParsed: studentData.secondaryGuardianPhoneParsed.national_number ? studentData.secondaryGuardianPhoneParsed : {country_code: '1', national_number: '', region_code: DEFAULT_REGION_CODE},
          relationship: studentData.secondaryGuardianRelationship
        },
        photo: {
          image: studentData.profilePhoto,
        },
      }

      customFormData = studentData.customData;
    } else {
			formData = {
				name: {firstName: '', lastName: ''},
        phone: '1',
        phoneParsed: {country_code: '1', national_number: '', region_code: DEFAULT_REGION_CODE},
				address: {street: '', unit: '', city: '', province: DEFAULT_PROVINCE, country: DEFAULT_COUNTRY, postalCode: ''},
        createdOn: moment().format('YYYY-MM-DD'),
        primaryGuardian: {name: '', phone: '1', email: '', relationship: '', phoneParsed: {country_code: '1', national_number: '', region_code: DEFAULT_REGION_CODE}},
        secondaryGuardian: {name: '', phone: '1', email: '', relationship: '', phoneParsed: {country_code: '1', national_number: '', region_code: DEFAULT_REGION_CODE}},
        customData: {},
      }
      customFormData = {};
    }

    this.setState({
      formData,
      customFormData,
    })
  }

  // formData -> studentData
  formDataToStudent() {
    const {
      formData,
      customFormData,
    } = this.state;

    let newStudentData = {
      ...formData,

      firstName: formData.name.firstName,
      lastName: formData.name.lastName,
      gender: formData.gender,
      dob: formData.dob ? moment(formData.dob).format('YYYY-MM-DD') : '',
      phone: formData.phoneParsed.country_code.toString() + formData.phoneParsed.national_number.toString(),
      profilePhoto: formData.profilePhoto,
      nickName: formData.nickName,
      suiteNumber: formData.address.unit,
      city: formData.address.city,
      address: formData.address.street,
      country: formData.address.country,
      province: formData.address.province,
      postalCode: formData.address.postalCode,
      primaryGuardianName: formData.primaryGuardian.name,
      primaryGuardianEmail: formData.primaryGuardian.email,
      primaryGuardianPhone: formData.primaryGuardian.phoneParsed.national_number.length > 2 ? formData.primaryGuardian.phoneParsed.country_code + formData.primaryGuardian.phoneParsed.national_number : '',
      primaryGuardianRelationship: formData.primaryGuardian.relationship,
      secondaryGuardianName: formData.secondaryGuardian.name,
      secondaryGuardianEmail: formData.secondaryGuardian.email,
      secondaryGuardianPhone: formData.secondaryGuardian.phoneParsed.national_number.length > 2 ? formData.secondaryGuardian.phoneParsed.country_code + formData.secondaryGuardian.phoneParsed.national_number : '',
      secondaryGuardianRelationship: formData.secondaryGuardian.relationship,
      createdOn: formData.createdOn ? moment(formData.createdOn).format('YYYY-MM-DD') : '',

      customData: customFormData,
    }
    
    // delete newStudentData.address
    delete newStudentData.name
    delete newStudentData.phoneParsed
    delete newStudentData.primaryGuardian
    delete newStudentData.secondaryGuardian

    return new Student(newStudentData);
  }

	proceed(res, student) {
		this.props.proceed({
			result: res.result,
      student,
		});
	}

	studentPhotoUploader(file, progress, done) {
    if (file) {
      updateStudentPhoto(this.props.studentData.id, file)
      .then((res) => {
        student.profilePhoto = res.save_to;

        updateStudentInfo(this.props.studentData.id, student)
        .then((res)=>{
          this.proceed(res, student);
        })
        .catch(()=>{});

      });
      return;
    }
  }

  onFormChange(formData) {
    this.setState({
      formData:{
        ...this.state.formData,
        ...formData
      }
    })
  }

  onCustomDataChange(customFormData){
    this.setState({
      customFormData:{
        ...this.state.customFormData,
        ...customFormData,
      }
    })
  }

  submitForm() {
    const {
      mode,
    } = this.props;

    const {
      formData,
    } = this.state;

    this.setState({disabledBtn: true})

    const schoolId = localStorage.getItem('schoolId');

    const validateResult = this.validate();
    const customDataValidateResult = this.customDataValidate();

    if (!validateResult.ok || !customDataValidateResult.ok) {
      this.setState({disabledBtn: false})
      return;
    }

    const convertedStudent = this.formDataToStudent();


    if(mode == 'create') {
      let studentToCreate = convertedStudent.toFormData('v6');

      if (formData.photo && formData.photo.file) {
        studentToCreate.photo = formData.photo.file;
      }

      createStudent(schoolId, studentToCreate)
      .then((res)=> {
        const studentWithID = new Student({
          id: res.schoolStudentID,
          ...convertedStudent,
        });

        this.proceed(res, studentWithID);
      })

    } else if (mode == 'update'){
      let studentUpdated = convertedStudent.toFormData('v5');
      if (formData.photo.file) {
        studentUpdated.photo = formData.photo.file;
      }
      updateStudentInfo(this.props.studentData.id, studentUpdated)
      .then((res)=>{
        this.proceed(res, convertedStudent);
      })
    }
  }

	render() {
    let {
      show,
      proceed,
      dismiss,
      cancel,
      mode
    } = this.props;

    let {
      formData,
      customFormData,
    } = this.state;

    const schoolId = localStorage.getItem('schoolId')

    const headerTitle = mode == 'create' ? __('New Student', locale) : `${formData.name.firstName} ${formData.name.lastName}`;

		return (
      <Modal
        className='create-class-modal'
        isShowingModal={show}

        onCloseModalClick={dismiss}
        fixedWidth={600}
        overlayColor="#000"

        hasHeader={true}
        headerTitle={headerTitle}
        headerType="bold"
        footerType="grey"
        hasFooter={true}

        getContentRef={(ref)=>{
          this.modalContentRef = ref;
        }}

        footerButtons={[
          {
            title: __('Complete', 'appwrapper'),
            className: `btn btn-primary pull-right`,
            onClick: this.submitForm,
						isDisabled: ()=>{
							return this.state.disabledBtn
						}
          },
        ]}
      >
        <ModalContent
          {...this.props}

          onFormChange={this.onFormChange}
          onCustomDataChange={this.onCustomDataChange}
          formData={formData}
          scrollingContainerRef={this.modalContentRef}
          customFormData={customFormData}
          getCustomDataValidationRef={(fn)=>{
            this.customDataValidate = fn;
          }}
          getValidationRef={(fn)=>{
            this.validate = fn;
          }}
					studentPhotoUploader={this.studentPhotoUploader}
        />
      </Modal>
    );
  }
}

export default connect(mapStateToProps)(confirmable(ModalBody));



// WEBPACK FOOTER //
// ./src/template/Modals/CreateStudent/ModalBody.js